// Stránky investičních bytů – samostatný bundle (webpack entry `reality` -> dist/reality.js).
// Vanilla JS, bez jQuery. Každý modul se hned vrátí, když na stránce nemá svůj markup.

import initRealityCalc from './calc-ui';
import initRealityDatepicker from './datepicker';
import initRealityFaq from './faq';
import initRealityForm from './form';
import initRealityPalace from './palace';
import initRealityRows from './rows';
import initRealitySubnav from './subnav';

document.addEventListener('DOMContentLoaded', () => {
  initRealityCalc(); // kalkulačka růstu hodnoty / výnosu z nájmu ([data-re-calc])
  initRealityFaq(); // harmonika častých dotazů ([data-re-faq])
  initRealityForm(); // předvýběr jednotky ve formuláři z karty / řádku garáže ([data-re-pick])
  initRealityRows(); // klik na řádek tabulky nabídky → detail inzerátu ([data-re-href])
  initRealitySubnav(); // aktivní položka menu sekcí podle scrollu (.re-subnav__link)
  initRealityPalace(); // EFI Palace: filtr ceníku, kalkulačka s požívacím právem, předvyplnění formuláře z detailu bytu
  initRealityDatepicker(); // kalendář termínu prohlídky (datum Fluent Forms), založený dřív než bundle
});
